import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { taskInquiryActionTypes } from '../actions/actionTypes';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const TaskInquiry = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // Configure Page Details
    case taskInquiryActionTypes.SET_TASKINQ_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case taskInquiryActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default TaskInquiry;
